import React, { useEffect } from "react";
import { SlideshowLightbox } from "lightbox.js-react";
import "lightbox.js-react/dist/index.css";


import image1 from "../../assets/images/compressed/1000135680.png";
import image2 from "../../assets/images/compressed/1000135684.png";
import image3 from "../../assets/images/compressed/1000135686.png";
import image4 from "../../assets/images/compressed/1000135692.png";
import image5 from "../../assets/images/compressed/1000135695.png";
import image6 from "../../assets/images/compressed/1000135698.png";
import image7 from "../../assets/images/compressed/1000135703.png";
import image8 from "../../assets/images/compressed/1000135705.png";
import image9 from "../../assets/images/compressed/1000135708 (1).png";
import image10 from "../../assets/images/compressed/1000135712.png";
import image11 from "../../assets/images/compressed/1000135715.png";
import image12 from "../../assets/images/compressed/1000135717.png";
import image13 from "../../assets/images/compressed/1000135719.png";
import image14 from "../../assets/images/compressed/1000135723.png";
import image15 from "../../assets/images/compressed/1000135727.png";
import image16 from "../../assets/images/compressed/1000135730.png";
import image17 from "../../assets/images/compressed/1000135733.png";
import image18 from "../../assets/images/compressed/1000135738.png";
import image19 from "../../assets/images/compressed/1000135740.png";
import image20 from "../../assets/images/compressed/1000135748.png";
import image21 from "../../assets/images/compressed/1000135751.png";
import image22 from "../../assets/images/compressed/1000135753.png";
import image23 from "../../assets/images/compressed/1000135756.png";
import image24 from "../../assets/images/compressed/1000135762.png";
import image25 from "../../assets/images/compressed/1000135767.png";
import image26 from "../../assets/images/compressed/1000135771.png";
import image27 from "../../assets/images/compressed/1000135775.png";
import image28 from "../../assets/images/compressed/1000135779.png";
import image29 from "../../assets/images/compressed/1000135783.png";
import image30 from "../../assets/images/compressed/1000135787.png";
import image31 from "../../assets/images/compressed/1000135791.png";
import image32 from "../../assets/images/compressed/1000135795.png";
import image33 from "../../assets/images/compressed/1000135799.png";
import image34 from "../../assets/images/compressed/1000135801.png";
import image35 from "../../assets/images/compressed/1000135803.png";
import image36 from "../../assets/images/compressed/1000135806.png";
import image37 from "../../assets/images/compressed/1000135815.png";
import image38 from "../../assets/images/compressed/1000135817.png";
import image39 from "../../assets/images/compressed/1000135823.png";
import image40 from "../../assets/images/compressed/1000135827.png";
import image41 from "../../assets/images/compressed/1000135832.png";
import image42 from "../../assets/images/compressed/1000135837.png";



import image101 from "../../assets/images/Projects/Projects/image101.JPG";
import image102 from "../../assets/images/Projects/Projects/image102.JPG";
import image103 from "../../assets/images/Projects/Projects/image103.JPG";
import image104 from "../../assets/images/Projects/Projects/image104.JPG";
import image105 from "../../assets/images/Projects/Projects/image105.JPG";
import image106 from "../../assets/images/Projects/Projects/image106.JPG";
import image107 from "../../assets/images/Projects/Projects/image107.JPG";
import image108 from "../../assets/images/Projects/Projects/image108.JPG";
import image109 from "../../assets/images/Projects/Projects/image109.JPG";
import image110 from "../../assets/images/Projects/Projects/image110.JPG";
import image111 from "../../assets/images/Projects/Projects/image111.JPG";
import image112 from "../../assets/images/Projects/Projects/image112.JPG";
import image113 from "../../assets/images/Projects/Projects/image113.JPG";
import image114 from "../../assets/images/Projects/Projects/image114.JPG";
import image115 from "../../assets/images/Projects/Projects/image115.JPG";
import image116 from "../../assets/images/Projects/Projects/image116.JPG";
import image117 from "../../assets/images/Projects/Projects/image117.JPG";
import image118 from "../../assets/images/Projects/Projects/image118.JPG";
import image119 from "../../assets/images/Projects/Projects/image119.JPG";
import image120 from "../../assets/images/Projects/Projects/image120.jpg";


import AOS from "aos";
import "aos/dist/aos.css";
import Metatag from "../../components/Metatag/Metatag";

const Joinus = () => {
  useEffect(()=>{
    window.scrollTo(0,0)
  },[])

  useEffect(()=>{
    AOS.init({
      once:true,
    })
  },[])

  const images = [
    { src: image1, alt: "img1" },
    { src: image2, alt: "img2" },
    { src: image3, alt: "img3" },
    { src: image4, alt: "img4" },
    { src: image5, alt: "img7" },
    { src: image6, alt: "img8" },
    { src: image7, alt: "img9" },
    { src: image8, alt: "img10" },
    { src: image9, alt: "img11" },
    { src: image10, alt: "img12" },
    { src: image11, alt: "img13" },
    { src: image12, alt: "img1" },
    { src: image13, alt: "img3" },
    { src: image14, alt: "img4" },
    { src: image15, alt: "img7" },
    { src: image16, alt: "img8" },
    { src: image17, alt: "img9" },
    { src: image18, alt: "img10" },
    { src: image19, alt: "img11" },
    { src: image20, alt: "img12" },
    { src: image21, alt: "img13" },
    { src: image22, alt: "img2" },
    { src: image23, alt: "img3" },
    { src: image24, alt: "img4" },
    { src: image25, alt: "img7" },
    { src: image26, alt: "img8" },
    { src: image27, alt: "img9" },
    { src: image28, alt: "img10" },
    { src: image29, alt: "img11" },
    { src: image30, alt: "img12" },
    { src: image31, alt: "img13" },
    { src: image32, alt: "img2" },
    { src: image33, alt: "img3" },
    { src: image34, alt: "img4" },
    { src: image35, alt: "img7" },
    { src: image36, alt: "img8" },
    { src: image37, alt: "img9" },
    { src: image38, alt: "img10" },
    { src: image39, alt: "img11" },
    { src: image40, alt: "img12" },
    { src: image41, alt: "img1" },
    { src: image42, alt: "img2" },
     { src: image101, alt: "img101" },
  { src: image102, alt: "img102" },
  { src: image103, alt: "img103" },
  { src: image104, alt: "img104" },
  { src: image105, alt: "img105" },
  { src: image106, alt: "img106" },
  { src: image107, alt: "img107" },
  { src: image108, alt: "img108" },
  { src: image109, alt: "img109" },
  { src: image110, alt: "img110" },
  { src: image111, alt: "img111" },
  { src: image112, alt: "img112" },
  { src: image113, alt: "img113" },
  { src: image114, alt: "img114" },
  { src: image115, alt: "img115" },
  { src: image116, alt: "img116" },
  { src: image117, alt: "img117" },
  { src: image118, alt: "img118" },
  { src: image119, alt: "img119" },
  { src: image120, alt: "img120" },

  ];

  return (
    <div>
      <Metatag title="Join Us - Be a Part of Our Community | Megavolt Technical Services" description="Explore exciting opportunities and become a valued member Megavolt Technical Services. Join us to grow,connect, and make an impact. Learn more about our mission and how you can get involved today!" link="joinus"/>
      <h1 className="font-bold text-3xl text-center my-8">Our Projects</h1>

      <div className="mx-auto p-3 lg:container md:py-6">
        <div>
          <SlideshowLightbox
            lightboxIdentifier="lightbox1"
            framework="next"
            images={images}
          >
            <div className="grid md:grid-cols-3 grid-cols-1 gap-2 md:gap-4">
              {images.map((image, index) => (
                <div
                  key={index}
                  className="relative overflow-hidden rounded group"
                  data-aos="zoom-in"
                  data-aos-duration="1000"
                  data-aos-offset='50'
                  data-aos-delay={index * 100}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    data-lightboxjs="lightbox1"
                    className="w-full h-full object-cover aspect-[4/3] transition duration-300 ease-in-out group-hover:scale-110"
                    loading="eager"
                    priority
                  />
                  <div className="absolute inset-0 bg-[#00000034] group-hover:hidden"></div>
                </div>
              ))}
            </div>
          </SlideshowLightbox>
        </div>
      </div>
    </div>
  );
};

export default Joinus;
